import type { SVGProps } from "react";
export interface CoffeeBeanIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function CoffeeBeanIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: CoffeeBeanIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M17.282 2.638a1.125 1.125 0 0 1 .63 2.159 6.3 6.3 0 0 0-2.74 1.632c-1.605 1.604-1.822 3.435-2.053 5.686-.225 2.195-.464 4.812-2.698 7.046a8.56 8.56 0 0 1-3.703 2.202l-.113.026a1.125 1.125 0 0 1-.517-2.187l.341-.108a6.3 6.3 0 0 0 2.4-1.524c1.604-1.604 1.821-3.433 2.052-5.685.225-2.195.465-4.812 2.7-7.047a8.55 8.55 0 0 1 3.701-2.2"
      />
      <path
        fill={color}
        d="M13.055 1.967c2.549-.344 5.092.272 6.9 2.079 1.806 1.807 2.422 4.35 2.078 6.9-.345 2.547-1.649 5.168-3.784 7.303s-4.756 3.44-7.304 3.784-5.092-.272-6.899-2.079-2.423-4.35-2.079-6.9c.345-2.547 1.649-5.168 3.784-7.303s4.756-3.44 7.304-3.784m5.308 3.67c-1.204-1.205-2.99-1.712-5.006-1.44-2.018.272-4.197 1.327-6.015 3.145s-2.873 3.997-3.145 6.015c-.272 2.015.235 3.802 1.44 5.006s2.99 1.713 5.007 1.44c2.017-.272 4.196-1.326 6.014-3.145s2.873-3.997 3.145-6.014c.273-2.016-.235-3.802-1.44-5.007"
      />
    </svg>
  );
}
